import React from 'react';

import { EmailIcon, styled } from '@asicsdigital/oneasics-blocks';

const EmailText = styled.div(({ theme }) => ({
  color: theme.colors.textPrimary,
  fontSize: theme.fontSizes.small,
  marginInlineStart: '4px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '270px',
}));

const EmailContainer = styled.span({
  display: 'flex',
});

// A component that displays a mail icon and an email address.
const EmailAddress = ({ children }) => (
    <EmailContainer>
      <img alt='email-icon' src={EmailIcon} />
      <EmailText id="email-address" name="email-address">{children}</EmailText>
    </EmailContainer>
  );

export default EmailAddress;
